export default __webpack_public_path__ + "static/avatar-do-2-2b12ce678ad0c18c246cd9141c2b8c3a.png";